// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mondayConnectionButton {
  background: #F9F9F9 0% 0% no-repeat padding-box;
  border: 1px solid #0079DE;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font: normal normal bold 16px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #0079DE;
  opacity: 1;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 200px;
}

.connectionStatusText {
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Step1/Step1.scss"],"names":[],"mappings":"AAAA;EACI,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;AACJ;;AAGI;EACI,iBAAA;AAAR","sourcesContent":[".mondayConnectionButton{\n    background: #F9F9F9 0% 0% no-repeat padding-box;\n    border: 1px solid #0079DE;\n    border-radius: 4px;\n    opacity: 1;\n    text-align: center;\n    font: normal normal bold 16px/19px Helvetica Neue;\n    letter-spacing: 0px;\n    color: #0079DE;\n    opacity: 1;\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    width: 200px;\n    }\n\n\n    .connectionStatusText{\n        margin-left: 20px;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
